// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2CE21","right":"Footer_right__27_Ld","buttons":"Footer_buttons__Kr-1u"};